import { render, staticRenderFns } from "./user-permissions.vue?vue&type=template&id=870e69c6&scoped=true"
import script from "./user-permissions.vue?vue&type=script&lang=js"
export * from "./user-permissions.vue?vue&type=script&lang=js"
import style0 from "./user-permissions.vue?vue&type=style&index=0&id=870e69c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870e69c6",
  null
  
)

export default component.exports